import { branch, memberKey } from './constants'
import ConfigQuery from './ConfigQuery'

class ConfigNode extends Weaver.Node

  constructor: (id) ->
    super(id)
    @relation(memberKey).add(@getType())

  @load: (id, NodeClass) ->
    new ConfigQuery()
      .restrict(id)
      .first(NodeClass or @)

  @list: (limit = 1000, skip = 0) ->
    new ConfigQuery()
      .type(@)
      .limit(limit)
      .skip(skip)
      .find(@)

  @getTypeNode: ->
    ConfigNode.get("#{ @className }")

  getType: ->
    ConfigNode.get("#{ @constructor.className }")

  loadFromQuery: ->
    type = @.relation(memberKey).first()
    model[type.id()]

  save: (params) ->
    super({ params..., branch })


export default ConfigNode
